import cn from 'classnames'

import { useEffect } from 'react'

import { useTranslation } from 'utils/use-translation'

import { useHeader } from '../../utils/use-header'

import { exchangeSlides } from '../home/components/swiper-component/assets/slides'

import useLocationSearch from '../../libs/location-search'

import { saveReferralId } from '../../libs/local-storage'

import ExchangeCrypto from './exchange-crypto'
import HowToExchange from './how-to-exchange'

import styles from './styles.module.scss'
import WhyCoinrabbit from './why-coinrabbit'
import ExchangeCommunity from './exchange-community'
import ExchangeFaq from './exchange-faq'
import { ExchangePairs } from './exchange-pairs'

export default function Exchange() {
  const { t } = useTranslation()

  const query = useLocationSearch()
  const referralId = Array.isArray(query.referral) ? query.referral[0] : query.referral

  useEffect(() => {
    if (referralId) {
      saveReferralId(referralId)
    }
  }, [referralId])

  const head = useHeader(t('exchange_crypto'), t('calculate_cryptocurrency_exchange'))

  const questions = [
    {
      title: t('what_is_exchange'),
      answer: t('what_is_exchange_answer'),
    },
    {
      title: t('how_trade'),
      answer: t('how_trade_answer'),
    },
    {
      title: t('what_affects'),
      answer: t('what_affects_answer'),
    },
    {
      title: t('how_exchange'),
      answer: t('how_exchange_answer'),
    },
  ]

  return (
    <div className={styles.exchange}>
      {head}
      <ExchangeCrypto />
      <section className={styles.section}>
        <div className={cn(styles.section__header, styles.margin)}>
          <h2 className={cn(styles.section__title)}>{t('how_exchange_title')}</h2>
        </div>
        <HowToExchange />
      </section>

      <section className={styles.section}>
        <div className={cn(styles.section__header)}>
          <h2 className={cn(styles.section__title)}>{t('popular_pairs')}</h2>
        </div>
        <ExchangePairs />
      </section>

      <section className={styles.section}>
        <div className={cn(styles.section__header, styles.section__header_whyCoinrabbit)}>
          <h2 className={cn(styles.section__title)}>{t('platform_for_everyone')}</h2>
          <p className={styles.section__subtitle}>{t('simple_safe_solution_all_needs')}</p>
        </div>

        <WhyCoinrabbit />
      </section>

      <section className={styles.section}>
        <div className={cn(styles.section__header, styles['section__header_without-margin'])}>
          <h2 className={cn(styles.section__title)}>{t('crypto_community_trusts_us')}</h2>
        </div>
        <ExchangeCommunity slides={exchangeSlides} />
      </section>

      <section className={styles.section}>
        <div className={styles.section__header}>
          <h2 className={cn(styles.section__title, styles.section__title_left)}>{t('faq')}</h2>
        </div>
        <ExchangeFaq questions={questions} />
      </section>
    </div>
  )
}
